export default function ConfirmModal({ open, title, message, onConfirm, onCancel, confirmLabel = 'Supprimer', confirmColor = '#b91c1c' }) {
  if (!open) return null;
  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '20px' }}
      onClick={onCancel}
    >
      <div
        style={{ background: 'white', borderRadius: '16px', padding: '28px', maxWidth: '400px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.22)' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
          <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: `${confirmColor}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={confirmColor} strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <div style={{ fontWeight: 800, fontSize: '1.05rem', color: '#1e293b' }}>{title}</div>
        </div>
        <div style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '24px', lineHeight: 1.6 }}>{message}</div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{ padding: '9px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#f8fafc', color: '#374151', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            style={{ padding: '9px 20px', borderRadius: '8px', border: 'none', background: confirmColor, color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: '0.9rem' }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
